import { defaultLocale, localeMeta, type Locale } from "../i18n/siteCopy";

function normalize(pathname: string) {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "");
}

export function parseSitePath(pathname: string): { locale: Locale; contentPath: string } {
  const normalized = normalize(pathname);

  for (const [locale, meta] of Object.entries(localeMeta) as Array<[Locale, (typeof localeMeta)[Locale]]>) {
    if (normalized === meta.route) {
      return { locale, contentPath: "/" };
    }
    if (normalized.startsWith(`${meta.route}/`)) {
      return { locale, contentPath: normalized.slice(meta.route.length) || "/" };
    }
  }

  return { locale: defaultLocale, contentPath: normalized };
}

export function buildLocalizedPath(locale: Locale, contentPath = "/") {
  const normalized = normalize(contentPath);
  if (normalized === "/") return localeMeta[locale].route;
  return `${localeMeta[locale].route}${normalized.startsWith("/") ? normalized : `/${normalized}`}`;
}

